import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

//Actions
export const FETCH_SERVICE_INVOICE_ROWS = "fetchServiceInvoiceRows";
export const FETCH_SERVICE_INVOICE_ROW = "fetchServiceInvoiceRow";
export const SAVE_SERVICE_INVOICE_ROW = "saveServiceInvoiceRow";
export const UPDATE_SERVICE_INVOICE_ROW = "updateServiceInvoiceRow";
export const DELETE_SERVICE_INVOICE_ROW = "deleteServiceInvoiceRow";
export const SEARCH_SERVICE_INVOICE_ROWS_BY_NAME =
  "searchServiceInvoiceRowsByName";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingServiceInvoiceRow";

const state = {
  errors: [],
  isLoadingServiceInvoiceRow: false
};

const getters = {
  isLoadingServiceInvoiceRow() {
    return state.isLoadingServiceInvoiceRow;
  }
};

const actions = {
  [FETCH_SERVICE_INVOICE_ROWS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-invoice-rows" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_SERVICE_INVOICE_ROW](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-invoice-rows", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_SERVICE_INVOICE_ROW](context, payload) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.post("service-invoice-rows", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_SERVICE_INVOICE_ROW](context, params) {
    context.commit(SET_LOADING, true);

    const id = params.id;

    return new Promise((resolve, reject) => {
      ApiService.update("service-invoice-rows", id, params.payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_SERVICE_INVOICE_ROW](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("service-invoice-rows", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SEARCH_SERVICE_INVOICE_ROWS_BY_NAME](context, name) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get(`service-invoice-rows/search-by-name?name=${name}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingServiceInvoiceRow = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingServiceInvoiceRow = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
